<template>
  <!-- «Terminar ahora» of a class left started and forgotten (card «clases
       olvidadas», 27-oct): it is closed with its duration (the type's,
       editable) and optional km; the student signs later from his profile and
       the teacher from the class page. It is not an incident. -->
  <div class="late-end" v-if="forgotten">
    <div class="late-end-note">
      <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
      <span>{{ s.note }}</span>
    </div>
    <div class="bottom-action">
      <button class="late-end-open" v-on:click="open()">
        <font-awesome-icon :icon="['fas', 'flag-checkered']" /> {{ s.button }}
      </button>
    </div>
    <transition name="fade">
      <div class="late-end-backdrop" v-if="form.open" v-on:click.self="form.open = false">
        <div class="late-end-form">
          <h3>{{ s.title }}</h3>
          <p class="late-end-explain">{{ s.explain }}</p>
          <label>{{ s.minutes }}</label>
          <input type="number" min="1" :max="2 * practice.time" v-model.number="form.minutes" />
          <label>{{ s.km_end }}</label>
          <input type="number" :min="practice.km_start" :placeholder="s.km_placeholder.replace('{km}', practice.km_start)" v-model.number="form.km" />
          <p class="late-end-signatures">{{ s.signatures }}</p>
          <div class="late-end-actions">
            <button class="late-end-secondary" :disabled="saving" v-on:click="form.open = false">{{ s.back }}</button>
            <button class="h-button default" :disabled="saving" v-on:click="save()">{{ s.save }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'late-end-sheet-component',
  props: {
    app: Object,
    // The class as /practice/read/one gives it (id, date, hour, minute, time,
    // km_start, started, ended, cancelled).
    practice: Object,
    // Open the form when the page loads (from the home block).
    autoOpen: Boolean
  },
  data () {
    return {
      saving: false,
      form: {
        open: false,
        minutes: 0,
        km: ''
      }
    }
  },
  computed: {
    s () {
      return this.app.strings.components.practice.late_end
    },
    // Started, not ended, and an hour past its planned end (the server
    // checks the same in the school's time).
    forgotten () {
      let p = this.practice
      if (!p || p.started !== 1 || p.ended === 1 || p.cancelled === 1) {
        return false
      }
      let end = new Date(p.date)
      end.setHours(parseInt(p.hour), parseInt(p.minute) + parseInt(p.time) + 60, 0, 0)
      return end < new Date()
    }
  },
  watch: {
    forgotten (value) {
      if (value && this.autoOpen) {
        this.open()
      }
    }
  },
  mounted () {
    if (this.forgotten && this.autoOpen) {
      this.open()
    }
  },
  methods: {
    open () {
      this.form = {open: true, minutes: parseInt(this.practice.time), km: ''}
    },
    save () {
      this.saving = true
      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.end,
        {
          id: this.practice.id,
          late: true,
          time_real: parseInt(this.form.minutes) || 0,
          km_start: parseInt(this.form.km) || 0,
          signature: '',
          teacher_signature: '',
          grade: 0
        },
        {emulateJSON: true, headers: {Authorization: 'Token ' + this.app.token}}
      ).then(response => {
        this.saving = false
        if (response.status === 200 && response.body.success === true) {
          this.form.open = false
          this.$swal({title: this.s.done, icon: 'success', timer: 1800, showConfirmButton: false})
          this.$emit('done')
          return
        }
        if (response.body && response.body.error && response.body.error.code === 'S100') {
          this.app.methods.logout()
          return
        }
        this.showRequestError(this.app.strings, 'practice-end', response.body.error)
      }, () => {
        this.saving = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

.late-end {
  margin: 12px 0;
}

.late-end-note {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  background-color: #fef2f2;
  color: #991b1b;
  font-size: 14px;
  line-height: 1.35;
}

.late-end-note > svg {
  margin-top: 2px;
}

.late-end-open {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 14px;
  background-color: $color-primary-1;
  color: #FFFFFF;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.late-end-backdrop {
  position: fixed;
  inset: 0;
  // Over the top bar, the side menu and the bottom button.
  z-index: 1200;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: rgba(15, 23, 42, 0.45);
}

.late-end-form {
  width: 100%;
  max-width: 520px;
  max-height: 92vh;
  overflow-y: auto;
  padding: 20px 18px 0;
  border-radius: 22px 22px 0 0;
  background-color: #FFFFFF;
  box-sizing: border-box;
  color: $text-color-1;
}

.late-end-form h3 {
  margin: 0 0 6px;
  font-size: 18px;
}

.late-end-explain,
.late-end-signatures {
  margin: 0 0 6px;
  color: $text-color-2;
  font-size: 13px;
  line-height: 1.4;
}

.late-end-signatures {
  margin-top: 12px;
}

.late-end-form label {
  display: block;
  margin: 12px 0 6px;
  color: $text-color-2;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.late-end-form input[type=number] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid $color-grey-light;
  border-radius: 12px;
  font: inherit;
  box-sizing: border-box;
}

// Always in sight, however long the form.
.late-end-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  position: sticky;
  bottom: 0;
  padding: 12px 0 calc(16px + env(safe-area-inset-bottom, 0px));
  background-color: #FFFFFF;
}

.late-end-actions > button {
  flex: 1;
}

.late-end-secondary {
  border: 1px solid $color-grey-light;
  border-radius: 12px;
  background-color: #FFFFFF;
  color: $text-color-1;
  font: inherit;
  cursor: pointer;
}
</style>
